import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectOutletActivationResultComponent } from './select-outlet-activation-result.component';

const routes: Routes = [
  {
    path: '',
    component: SelectOutletActivationResultComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectOutletActivationResultRoutingModule {}
